// extracted by mini-css-extract-plugin
module.exports = {"asterisk":"style_asterisk__DerbT","standard":"style_standard__yIr3L","error":"style_error__FwA3q","disabled":"style_disabled__eO1MZ"};